module.exports = {
  DOCUMENT_IDENTIFICATION_TYPE: {
    ENTITY_PERSON: 'ENTITY_PERSON',
    BANK_ACCOUNT: 'BANK_ACCOUNT',
    CONTACT: 'CONTACT',
    PAYMENT: 'PAYMENT'
  },
  DOCUMENT_CATEGORY_CODE: {
    CUSTOMER_REGISTRATION: 'CUSTOMER_REGISTRATION',
    ONBOARDING: 'ONBOARDING',
    PROFILE: 'PROFILE',
    EXTERNAL_BANK_AC_VERIFICATION: 'EXTERNAL_BANK_AC_VERIFICATION',
    ID_VERIFICATION: 'ID_VERIFICATION',
    TAX_ID: 'TAX_ID'
  },
  DOCUMENT_SUBCATEGORY_CODE: {
    ACCOUNT_AGREEMENT: 'ACCOUNT_AGREEMENT',
    BUSINESS_TYPE: 'BUSINESS_TYPE',
    CARDHOLDER_AUTHORIZATION: 'CARDHOLDER_AUTHORIZATION',
    DISPLAY_PICTURE: 'DISPLAY_PICTURE',
    ACH_DEBIT_AUTHORIZATION_LETTER: 'ACH_DEBIT_AUTHORIZATION_LETTER',
    CITIZENSHIP_PAPERS: 'CITIZENSHIP_PAPERS',
    DRIVERS_LICENCE: 'DRIVERS_LICENCE',
    DRIVERS_LICENSE_CANADIAN: 'DRIVERS_LICENSE_CANADIAN',
    EIN: 'EIN',
    EMPLOYER_IDENTIFICATION_NUMBER: 'EMPLOYER_IDENTIFICATION_NUMBER',
    FOREIGN: 'FOREIGN',
    GREEN_CARD: 'GREEN_CARD',
    ITIN: 'ITIN',
    NATIONAL_ID: 'NATIONAL_ID',
    OTHERS: 'OTHERS',
    PASSPORT: 'PASSPORT',
    SOCIAL_SECURITY_NUMBER: 'SOCIAL_SECURITY_NUMBER',
    SSN: 'SSN',
    VAT: 'VAT',
    VISA: 'VISA',
    CRB_CIP: 'CRB_CIP'
  }
};
